import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"ed-sheeran"> = {
  appId: "ed-sheeran",
  cookiePrefix: "ed",
  lang: "EN",
  artist: {
    name: "Ed Sheeran"
  },
  meta: {
    description: "Ed Sheeran"
  },
  emailSender: {
    name: "IYK",
    email: "hello@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "f4513e00-bb5f-4623-ac4b-9c5e06c45bf5",
    initialOwnerAddress: "0x10d601fab4e713254225fe06a44d665ab8dee24a"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(0)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: null,
  joinProof: null,
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://instagram.com/teddysphotos"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://tiktok.com/@edsheeran"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/edsheeran"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UC0C-w0YjGpqDXGB8IHb662A"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/EdSheeranMusic/"
    },
    {
      platform: SocialPlatform.Website,
      label: "Website",
      href: "https://www.edsheeran.com/"
    }
  ],
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.webp`,
          width: 128
        },
        background: `${appConfig.s3.assets.appUrl}/layout-background.webp`,
        howToTap: `${appConfig.s3.assets.appUrl}/how-to-tap.webp`,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 128
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.appUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: `${appConfig.s3.assets.appUrl}/merch/single-marquee.mp4`,
        howToTap: `${appConfig.s3.assets.appUrl}/how-to-tap.mp4`
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
